import React, { useMemo } from 'react';
import { Tabs } from 'react-bootstrap';
import { Switch, Route, Link } from 'react-router-dom';
import getLangData from '../../../../utils/getLangData';
import SubHeader from '../../../../_psb/layout/sub-header/SubHeader';
import FollowingList from './FollowingList';
// import ViewPublicInquiry from "./ViewPublicInquiry";

const publicInquiry = () => {
  return (
    <>
      <SubHeader title={getLangData().profile_types.supplier}>
        <Switch>
          {/* <Route
            exact
            path={['/customer-public-inquiry-supplier/', '/customer-public-inquiry-supplier']}
            component={() => (
              <Link
                to='/customer-public-inquiry-supplier/create'
                className='btn btn-brand btn-bold'
              >
                Add New{" "}
              </Link>
            )}
          /> */}
          <Route
            exact
            path='/customer-public-inquiry-supplier/:id'
            render={({ match: { params } }) => {
              return (
                <Link
                  to={`/supplier-followings`}
                  className='btn-label-brand btn btn-bold'
                >
                  {getLangData().buttons.back}
                </Link>
              );
            }}
          />
        </Switch>
      </SubHeader>
      <Switch>
        <Route exact component={FollowingList} path='/supplier-followings' />
        {/* <Route
      exact
      component={ViewPublicInquiry}
      path='/customer-public-inquiry-supplier/:id'
    />
      <Route
      exact
      component={ViewPublicInquiry}
      path='/customer-public-inquiry-supplier/create'
    /> */}
      </Switch>
    </>
  );
};

export default publicInquiry;
